module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/payment/carte-bleue-d6efe5b2971bd87a439b93bc19bb371a.svg";